import { Select, Form } from "antd";
import * as React from "react";
import CareConfigurationAPI from "src/admin/Organization/Datasets/CareConfigurationAPI";
import AuthorizationWrapper from "src/common/AuthorizationWrapper";
import { AdminPermissions } from "src/common/Permissions";
import { Validation } from "src/common/utils";

const { Option } = Select;

interface IProps {
	careConfigurationId?: number;
	careConfigurationVersionId?: number;
	onSelectedCareConfigurationVersionChange?: any;
}

interface IState {
	careConfigurations: CareConfigurationDTO[];
	careConfigurationVersions: CareConfigurationVersionDTO[];
	selectedCareConfigurationId?: number;
	selectedCareConfigurationVersionId?: number;
}

class CareConfigurationSelector extends React.Component<IProps, IState> {
	constructor(props: IProps) {
		super(props);
		this.state = {
			careConfigurations: [],
			careConfigurationVersions: [],
			selectedCareConfigurationId: this.props.careConfigurationId,
			selectedCareConfigurationVersionId: this.props.careConfigurationVersionId,
		};
	}

	public componentDidMount = async () => {
		// load CARE Configurations
		const p_configs = await CareConfigurationAPI.getConfigurations();

		// load CARE configuration versions
		const p_configVersions =
			await CareConfigurationAPI.getCareConfigurationVersions(
				this.props.careConfigurationId ? this.props.careConfigurationId : 0
			);

		Promise.all([p_configs, p_configVersions]).then((values) => {
			const [careConfigurations, careConfigurationVersions] = values;

			this.setState({ careConfigurations, careConfigurationVersions });
		});
	};

	public render() {
		const {
			careConfigurations,
			careConfigurationVersions,
			selectedCareConfigurationId,
			selectedCareConfigurationVersionId,
		} = this.state;

		const validCareConfiguration = {
			selectedCareConfigurationVersion: Validation.validateIfANumberOrNumbers(
				selectedCareConfigurationVersionId!
			),
		};

		const careConfigurationsOptions = careConfigurations.map((option) => (
			<Option key={option.id} value={option.id}>
				{option.name}
			</Option>
		));

		const careConfigurationVersionsOptions = careConfigurationVersions.map(
			(option) => (
				<Option key={option.id} value={option.id}>
					{option.version}
				</Option>
			)
		);

		return (
			<>
				<div className="row">
					<div className="col-6 form-group">
						<label>Vitals Configuration</label>
						<Form.Item>
							<AuthorizationWrapper
								type="disable"
								permissions={[AdminPermissions.EditDataset]}
							>
								<Select
									value={selectedCareConfigurationId}
									onChange={this.onSelectCareConfigurationChange}
								>
									{careConfigurationsOptions}
								</Select>
							</AuthorizationWrapper>
						</Form.Item>
					</div>
				</div>
				<div className="row">
					<div className="col-6 form-group">
						<label>Vitals Configuration Version</label>
						<Form.Item
							validateStatus={
								validCareConfiguration.selectedCareConfigurationVersion
									.validationStatus
							}
							help={
								validCareConfiguration.selectedCareConfigurationVersion.message
							}
							hasFeedback={true}
							required={true}
						>
							<AuthorizationWrapper
								type="disable"
								permissions={[AdminPermissions.EditDataset]}
							>
								<Select
									value={selectedCareConfigurationVersionId}
									onChange={this.onSelectedVersionChange}
								>
									{careConfigurationVersionsOptions}
								</Select>
							</AuthorizationWrapper>
						</Form.Item>
					</div>
				</div>
			</>
		);
	}

	onSelectCareConfigurationChange = (selectedCareConfigurationId: number) => {
		CareConfigurationAPI.getCareConfigurationVersions(
			selectedCareConfigurationId
		).then((careConfigurationVersions) => {
			this.setState({
				careConfigurationVersions,
				selectedCareConfigurationId,
				selectedCareConfigurationVersionId: undefined,
			});
		});
	};

	onSelectedVersionChange = (selectedCareConfigurationVersionId: number) => {
		this.setState({ selectedCareConfigurationVersionId });
		this.props.onSelectedCareConfigurationVersionChange(
			selectedCareConfigurationVersionId
		);
	};
}

export default CareConfigurationSelector;
